import axios from "axios";
import { useState, useEffect } from "react";
import { Loader, Placeholder } from "rsuite";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";

import AuthService from "../../services/auth.service";
import VoucherService from "../../services/voucher.service";

import { save } from "./save";
import { applyVoucher } from "./applyVoucher";
import { SubscriptionPackageForm } from "./SubscriptionPackageForm";

import "./subscriptionPackage.scss";
import "react-toastify/dist/ReactToastify.css";

const APP_URL = process.env.APP_URL;

const SubscriptionPackage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isCheckingVoucher, setIsCheckingVoucher] = useState(false);
  const [formData, setFormData] = useState(null);
  const [helps, setHelps] = useState(null);
  const [foreign, setForeign] = useState(null);
  const [selectedSubscriptionPackage, setSelectedSubscriptionPackage] =
    useState(null);
  const [code, setCode] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [isActiveText, setIsActiveText] = useState("کد تخفیف دارید؟");
  const [messageClass, setMessageClass] = useState("");
  const [messageType, setMessageType] = useState("");
  const [message, setMessage] = useState("");
  const [buttonStatus, setButtonStatus] = useState(true);
  const [buttonContent, setButtonContent] = useState("");
  const [subscriptionPackageFinalPrice, setSubscriptionPackageFinalPrice] =
    useState(null);
  const [
    subscriptionPackageFinalPriceText,
    setSubscriptionPackageFinalPriceText,
  ] = useState(null);
  const [trialDays, setTrialDays] = useState(null);
  const [shadow, setShadow] = useState(null);
  const [voucherAccept, setVoucherAccept] = useState(false);
  const [activeDiets, setActiveDiets] = useState(null);
  const [disableDiets, setDisableDiets] = useState(null);
  const [activeDiet, setActiveDiet] = useState(null);

  const user = AuthService.getCurrentUser()?.user;
  const isForeign = user?.is_foreign;
  const foreignCodeMessage = foreign?.show?.message;

  const navigate = useNavigate();

  if (
    (AuthService &&
      AuthService.getSubscription() &&
      !AuthService.getSubscription()?.is_expired &&
      !AuthService.getSubscription().trial_expired_at &&
      AuthService.getUser().subscription.days > 2) ||
    AuthService.getUser().reserved
  ) {
    window.location.href = "/subscriptions";
  }

  let searchParams = new URLSearchParams(document.location.search);

  if (
    searchParams.get("voucherCode") != null &&
    searchParams.get("voucherCode").length > 0 &&
    isActive === false
  ) {
    setIsActive(true);
    setCode(searchParams.get("voucherCode"));
  } else if (
    VoucherService.get() != null &&
    VoucherService.get().length > 0 &&
    isActive === false
  ) {
    setIsActive(true);
    setCode(VoucherService.get());
  }

  useEffect(() => {
    getFormData();
  }, []);

  const activeCodeGroup = (event) => {
    if (isForeign) {
      toast.info(foreignCodeMessage);
    } else {
      setIsActive(!isActive);
      setIsActiveText("کد تخفیف");
    }
  };

  const removeCode = () => {
    // 👇️ toggle isActive state on click
    setButtonStatus(true);
    setMessageClass("");
    setMessage("");
    setCode("");
    setMessageType("");
    setVoucherAccept(false);
    handleOnChangeSubscriptionPackage(selectedSubscriptionPackage, false);
  };

  const resetInput = () => {
    setButtonStatus(true);
    setMessageClass("");
    setMessage("");
    setMessageType("");
    handleOnChangeSubscriptionPackage(selectedSubscriptionPackage, false);
  };

  const handleChange = (id) => {
    const activeDiet = formData.find((item) => item.id === id);
    setActiveDiet(activeDiet);
    setSelectedSubscriptionPackage(null);
    setSubscriptionPackageFinalPrice(null);
  };

  return (
    <div className="container subscription-package-route">
      <div className="form-container">
        <div className="center">
          {formData ? (
            render()
          ) : (
            <>
              <Placeholder.Paragraph rows={8} />
              <Loader backdrop content="درحال بارگذاری ..." vertical />
            </>
          )}
        </div>
      </div>

      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );

  function handleApplyVoucher(subscriptionPackage) {
    applyVoucher({
      subscriptionPackage,
      code,
      isLoading,
      isCheckingVoucher,
      setButtonStatus,
      setIsLoading,
      setIsCheckingVoucher,
      setVoucherAccept,
      setMessageClass,
      setMessage,
      setMessageType,
      setButtonContent,
      setSubscriptionPackageFinalPrice,
      setSubscriptionPackageFinalPriceText,
      setTrialDays,
      navigate,
    });
  }

  function handleOnChangeSubscriptionPackage(
    subscriptionPackage,
    hasVoucher = true
  ) {
    if (subscriptionPackage) {
      setSubscriptionPackageFinalPrice(subscriptionPackage.final_price);
      setSubscriptionPackageFinalPriceText(
        subscriptionPackage.final_price_text
      );
      setSelectedSubscriptionPackage(subscriptionPackage);
      setTrialDays(null);

      if (hasVoucher) {
        handleApplyVoucher(subscriptionPackage);
      }
      setShadow(subscriptionPackage.id);
    }
  }

  function render() {
    let submitButtonText =
      subscriptionPackageFinalPrice === 0 ? "دریافت رایگان اشتراک" : "پرداخت";

    if (trialDays && trialDays > 0) {
      submitButtonText = `دریافت رایگان اشتراک ${trialDays} روزه`;
    }

    return (
      <SubscriptionPackageForm
        disableDiets={disableDiets}
        activeDiet={activeDiet}
        handleChange={handleChange}
        activeDiets={activeDiets}
        selectedSubscriptionPackage={selectedSubscriptionPackage}
        handleOnChangeSubscriptionPackage={handleOnChangeSubscriptionPackage}
        shadow={shadow}
        activeCodeGroup={activeCodeGroup}
        isActive={isActive}
        isActiveText={isActiveText}
        isCheckingVoucher={isCheckingVoucher}
        subscriptionPackageFinalPrice={subscriptionPackageFinalPrice}
        subscriptionPackageFinalPriceText={subscriptionPackageFinalPriceText}
        messageType={messageType}
        code={code}
        setCode={setCode}
        voucherAccept={voucherAccept}
        resetInput={resetInput}
        isLoading={isLoading}
        save={() =>
          save({
            isLoading,
            selectedSubscriptionPackage,
            code,
            activeDiet,
            searchParams,
            setIsLoading,
            handleNotfound,
            navigate,
          })
        }
        buttonStatus={buttonStatus}
        applyVoucher={handleApplyVoucher}
        removeCode={removeCode}
        message={message}
        messageClass={messageClass}
        submitButtonText={submitButtonText}
        helps={helps}
        buttonContent={buttonContent}
      />
    );
  }

  function getFormData() {
    if (formData || isLoading) {
      return formData;
    }

    const config = {
      headers: { Authorization: `Bearer ${AuthService.getAccessToken()}` },
    };

    setIsLoading(true);
    axios
      .get(`${APP_URL}/api/v6/diets`, config)
      .then(function (response) {
        const data = response.data.result;
        const elements = response.data.elements;
        setFormData(data);
        setHelps(elements.helps);
        setForeign(elements.foreign);
        const currentActiveDiets = data.filter((item) => item.status !== 2);
        const currentDisableDiets = data.filter((item) => item.status === 2);
        const currentActiveDiet = currentActiveDiets[0];
        const currentSelectedSubscriptionPackage =
          currentActiveDiet.subscription_packages.find(
            (item) => item.chosen === true
          );
        if (currentSelectedSubscriptionPackage) {
          handleOnChangeSubscriptionPackage(currentSelectedSubscriptionPackage);
        }
        setActiveDiets(currentActiveDiets);
        setDisableDiets(currentDisableDiets);
        setActiveDiet(currentActiveDiet);
        setIsLoading(false);
      })
      .catch(function (error) {
        setIsLoading(false);

        if (!error.response) {
          handleNotfound();

          return false;
        }

        const statusCode = error.response.status;
        switch (statusCode) {
          case 422:
            const { errors } = error.response.data;

            for (const errorsKey in errors) {
              const error = errors[errorsKey];

              toast.error(error, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
            }
            break;

          case 401:
            navigate("/auth");
            break;
          default:
            handleNotfound();

            break;
        }
      });
  }

  function handleNotfound() {
    return false;
  }
};

export default SubscriptionPackage;
